import SimpleNoise1D from "./utils/SimpleNoise1D";
import SimplexNoise from "./utils/SimplexNoise";

require('normalize.css/normalize.css');
require('./styles/index.scss');

// Import custom classes
import Point from "./classes/Point";
import Mouse from "./utils/mouse"
import mouse from "./utils/mouse";

// Init canvas and context
const canvas = document.querySelector('.main-canvas');
canvas.width = window.innerWidth * window.devicePixelRatio; // pour du rétina --> largeur CSS (innerWidth) * pixel ratio de l'écran
canvas.height = window.innerHeight * window.devicePixelRatio; // pour du rétina --> hauteur CSS (innerWidth) * pixel ratio de l'écran
const ctx = canvas.getContext("2d");

// Init variables and objects
let time = 0;
let points = [];
let noise = new SimplexNoise();
let steps = 100;
let scale = 20;
let frequency = 10;
const bounce = 0.05;
const point = new Point(ctx, canvas.width / 2, canvas.height / 2);
const pointBounce = new Point(ctx, canvas.width / 2, canvas.height / 2, 3);
const nbOr = 1.61803398875;

// Loop (60fps)
const update = () => {
    // ctx.globalAlpha = 0.05;
    // ctx.fillRect(0, 0, canvas.width, canvas.height);
    // ctx.globalAlpha = 1;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.save();
    ctx.translate(canvas.width / 2, canvas.height / 2);

    ctx.beginPath();
    ctx.strokeStyle = '#ffffff';
    ctx.moveTo(Math.cos(0) * scale, Math.sin(0) * scale);
    for (let i = 0; i <= steps; i++) {
        let progress = i / steps;
        let angle = progress * Math.PI * 2;

        let n = noise.noise2D(progress + time, (progress * frequency)) * 100;

        ctx.lineTo(Math.cos(angle) * (scale + n), Math.sin(angle) * (scale + n));
    }
    ctx.stroke();
    ctx.closePath();
    ctx.restore();

    // const mouseX = ((Mouse.cursor[0] + 1) / 2) * canvas.width;
    // const mouseY = ((Mouse.cursor[1] + 1) / 2) * canvas.height;
    //
    // points.push(new Point(ctx, mouseX, mouseY, 4, Math.random() * (10 - 5) + 5));
    // points.forEach(point => point.draw());
    //
    // points = points.filter(point => point.lifespan > 0);

    time += 0.01;
    requestAnimationFrame(update);
}

const update1 = () => {
    ctx.globalAlpha = 0.04;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = 1;

    ctx.save();
    ctx.translate(canvas.width / 2 + 150, canvas.height / 2 - 295);

    const mouseX = (canvas.width / 2 - ((Mouse.cursor[0] + 1) / 2) * canvas.width) * -1;
    const mouseY = (canvas.height / 2 - ((Mouse.cursor[1] + 1) / 2) * canvas.height) * -1;


    ctx.beginPath();
    for (let i = 0; i <= 100; i++) {
        const progress = i / 100;
        const angle = Math.PI * 2 * progress;
        const n = new SimpleNoise1D().getVal(progress);
        ctx.lineTo(Math.cos(angle) * 300 * n - 150, Math.sin(angle) * 300 * n + 295);
    }
    ctx.stroke();
    ctx.globalCompositeOperation = 'source-over';
    ctx.clip();
    ctx.closePath();

    for (let j = 0; j < 17; j++) {
        ctx.beginPath();

        let n = noise.noise4D(time, Math.cos(0), Math.sin(0), j * 0.2) * 30; // entre -100 et 100
        scale = (50 + (50 * j)) + n;

        ctx.moveTo(Math.cos(0) * scale, Math.sin(0) * scale);

        for (let i = 0; i <= steps; i++) {
            const progress = (i / steps);
            const angle = progress * Math.PI * 2; // radians

            const rgb = [Math.random() * 255, Math.random() * 255, Math.random() * 255];
            ctx.strokeStyle = `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
            ctx.lineWidth = 4;

            n = noise.noise4D(time, Math.cos(angle), Math.sin(angle), j * 0.2) * 30; // entre -100 et 100
            scale = (50 + (50 * j)) + n * 2;
            ctx.lineTo(Math.cos(angle) * scale,  Math.sin(angle) * scale);
        }

        ctx.stroke();
        ctx.closePath();
    }

    ctx.restore();

    time += 0.01;
    requestAnimationFrame(update1);
}

const update2 = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const mouseX = ((Mouse.cursor[0] + 1) / 2) * canvas.width;
    const mouseY = ((Mouse.cursor[1] + 1) / 2) * canvas.height;

    point.x = mouseX;
    point.y = mouseY;
    pointBounce.targetX = mouseX;
    pointBounce.targetY = mouseY;
    const distanceX = point.x - pointBounce.x;
    const distanceY = point.y - pointBounce.y;
    pointBounce.x += distanceX * bounce;
    pointBounce.y += distanceY * bounce;

    point.once();
    pointBounce.once();

    requestAnimationFrame(update2);
}

update1();
